import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    vertical-align: middle; 
    width: 100%;
    max-width: 92%;
    margin: 0px auto;
    padding: 0px 64px;
    
    @media (max-width: 1500px) {
        max-width: 96%;
    }
    
    @media (max-width: 1200px) {
        padding: 0px 24px;
        max-width: 98%;
    }
    
    @media (max-width: 768px) {
        padding: 0px 16px;
        max-width: 100%;
    }
    
    @media (max-width: 480px) {
        padding: 0px 12px;
    }

    .content {
        padding-bottom: 100px;
        width: 100%;
        justify-content: center;
        align-items: center;
        
        @media (max-width: 768px) {
            padding-bottom: 80px;
        }
        
        @media (max-width: 480px) {
            padding-bottom: 70px;
        }
    }

    .loaderc {
        display: flex;
        align-items: center;
        margin-top: 50px;
        justify-content: center;
        
        @media (max-width: 768px) {
            margin-top: 30px;
        }
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 40px;
    justify-content: center;
    position: relative;
    width: 100%;
    min-height: 100px;
    background: ${({ theme }) => theme.colors.interfacePure0};     

    .logo {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        /* limita o tamanho da logo (o SVG branco/vermelho do dark não tem largura
           intrínseca e renderizava gigante) — 185px = mesmo tamanho das telas principais */
        width: 185px;
        img, svg { width: 100%; height: auto; display: block; }

        @media (max-width: 768px) {
            position: static;
            transform: none;
            margin-bottom: 16px;
            width: 140px;
        }
    }

    h1 {
        font-size: 24px;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.interfaceText300};
        text-align: center;
        margin: 0;
        
        @media (max-width: 768px) {
            font-size: 20px;
        }
        
        @media (max-width: 480px) {
            font-size: 18px;
        }
    }
    
    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        gap: 16px;
        min-height: auto;
        margin-bottom: 24px;
    }
`;

export const Footer = styled.div`
    width: 100%;
    min-height: 100px;
    display: flex;
    align-items: center;
    padding: 0px 250px;
    justify-content: flex-end;
    position: fixed;
    right: 0;
    bottom: 0;  
    background: ${({ theme }) => theme.colors.interfacePure0};
    box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.05);
    z-index: 5;
    
    @media (max-width: 1100px) {
        padding: 0px 100px;
    }
    
    @media (max-width: 768px) {
        padding: 0px 20px;
        min-height: 80px;
    }
    
    @media (max-width: 480px) {
        padding: 0px 16px;
        min-height: 70px;
    }
    
    .btn-acoes {
        display: flex;
        gap: 16px;
        width: 100%;
        justify-content: flex-end;
        
        @media (max-width: 768px) {
            gap: 12px;
        }
        
        @media (max-width: 480px) {
            gap: 8px;
        }
        
        button {
            width: 160px;
            
            @media (max-width: 768px) {
                width: 140px;
            }
            
            @media (max-width: 480px) {
                width: 120px;
            }
        }
        
        .continue {
            background: ${({ theme }) => theme.colors.primaryRed400};
        }
    }
`;
